// extracted by mini-css-extract-plugin
export default {"container":"JE-z","modal":"KE-z","dimensions":"LE-z","brandName":"ME-z","productName":"NE-z","recipientEmail":"OE-z","recommendedFit":"PE-z","hiddenField":"QE-z"};